const IconRemove = props => {
  return (
    <svg
      {...props}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 1L1 11M1 1L11 11" stroke="currentColor" />
    </svg>
  );
};
export default IconRemove;
